import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import NoMatch from "./Pages/NoMatch";
import axios from "axios";

import Aos from "aos";
import { useEffect } from "react";
import "aos/dist/aos.css";
import "./styles/index.scss";
import "bootstrap/dist/js/bootstrap";

/**
 * Axios HTTP Request defaults
 */
axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.headers.common["Authorization"] =
  "Basic bXl1d2UubmV0OlV3ZUBVY2VzXzI0";

const ScrollToTop = React.lazy(() => import("./components/common/ScrollTop"));
const ScrollTopBehaviour = React.lazy(
  () => import("./components/common/ScrollTopBehavier")
);
const Home = React.lazy(() => import("./Pages/home/Home"));
const Platform = React.lazy(() => import("./Pages/home/Platform"));
const WhatsIncluded = React.lazy(
  () => import("./Pages/whatsincluded/WhatsIncluded")
);

const CreditRestoration = React.lazy(
  () => import("./Pages/whatsincluded/CreditRestoration")
);
const CreditMonitoring = React.lazy(
  () => import("./Pages/whatsincluded/CreditMonitoring")
);
const CreditAnalysis = React.lazy(
  () => import("./Pages/whatsincluded/CreditAnalysis")
);
const CreditAttorney = React.lazy(
  () => import("./Pages/whatsincluded/CreditAttorney")
);
const YFLFamilyMint = React.lazy(
  () => import("./Pages/whatsincluded/YFLFamilyMint")
);
const Budgeting = React.lazy(() => import("./Pages/whatsincluded/Budgeting"));
const NetWorth   = React.lazy(() => import("./Pages/whatsincluded/NetWorth"));
const DebtPayoff = React.lazy(() => import("./Pages/whatsincluded/DebtPayoff"));
const WillAndTrust = React.lazy(
  () => import("./Pages/whatsincluded/WillAndTrust")
);
const IdentityMonitoring = React.lazy(
  () => import("./Pages/whatsincluded/IdentityMonitoring")
);
const FinancialLockbox = React.lazy(
  () => import("./Pages/whatsincluded/FinancialLockbox")
);
const RocketLawyer = React.lazy(
  () => import("./Pages/whatsincluded/RocketLawyer")
);
const SavingsGoals = React.lazy(
  () => import("./Pages/whatsincluded/SavingsGoals")
);

const Testimonial = React.lazy(() => import("./Pages/testimonial/Testimonial"));
const Pricing = React.lazy(() => import("./Pages/pricing/Pricing"));
const ContactUs = React.lazy(() => import("./Pages/contactus/ContactUs"));
const CustAppNew = React.lazy(() => import("./Pages/enroll/CustAppNew"));
const PPQuizHome = React.lazy(() => import("./Pages/ppquiz/PPQuizHome"));
const Seo = React.lazy(() => import("./components/common/Seo"));
const PrivacyPolicy = React.lazy(() => import("./Pages/terms/PrivacyPolicy"));
const TermsofUse = React.lazy(() => import("./Pages/terms/TermsofUse"));
const AccessiblityStatement = React.lazy(
  () => import("./Pages/terms/AccessiblityStatement")
);
const FAQ =React.lazy(() => import("./Pages/faq/FAQ"));
const ProtectionThatPays =React.lazy(() => import("./Pages/protectionthatpays/ProtectionThatPays"));
function App() {
  useEffect(() => {
    Aos.init({
      duration: 1200,
    });
  }, []);
  return (
    <div className="main-page-wrapper app">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/home/" />} />
          <Route
            path="/*"
            index
            element={
              <React.Suspense fallback={<>...</>}>
                <NoMatch />
              </React.Suspense>
            }
          />

          <Route
            path="/home/*"
            element={
              <React.Suspense fallback={<>...</>}>
                <Home />
              </React.Suspense>
            }
          />
           <Route
            path="/platform/*"
            element={
              <React.Suspense fallback={<>...</>}>
                <Platform />
              </React.Suspense>
            }
          />
          <Route
            path="/whatsincluded/*"
            element={
              <React.Suspense fallback={<>...</>}>
                <WhatsIncluded />
              </React.Suspense>
            }
          />
          <Route
            path="/creditrestoration/*"
            element={
              <React.Suspense fallback={<>...</>}>
                <CreditRestoration />
              </React.Suspense>
            }
          />
             <Route
            path="/creditmonitoring/*"
            element={
              <React.Suspense fallback={<>...</>}>
                <CreditMonitoring />
              </React.Suspense>
            }
          />
          <Route
            path="/creditanalysis/*"
            element={
              <React.Suspense fallback={<>...</>}>
                <CreditAnalysis />
              </React.Suspense>
            }
          />
          <Route
            path="/creditattorney/*"
            element={
              <React.Suspense fallback={<>...</>}>
                <CreditAttorney />
              </React.Suspense>
            }
          />
          <Route
            path="/yflfamilymint/*"
            element={
              <React.Suspense fallback={<>...</>}>
                <YFLFamilyMint />
              </React.Suspense>
            }
          />
          <Route
            path="/budgeting/*"
            element={
              <React.Suspense fallback={<>...</>}>
                <Budgeting />
              </React.Suspense>
            }
          />
           <Route
            path="/networth/*"
            element={
              <React.Suspense fallback={<>...</>}>
                <NetWorth />
              </React.Suspense>
            }
          />
          <Route
            path="/debtpayoff/*"
            element={
              <React.Suspense fallback={<>...</>}>
                <DebtPayoff />
              </React.Suspense>
            }
          />
          <Route
            path="/willandtrust/*"
            element={
              <React.Suspense fallback={<>...</>}>
                <WillAndTrust />
              </React.Suspense>
            }
          />
          <Route
            path="/identitymonitoring/*"
            element={
              <React.Suspense fallback={<>...</>}>
                <IdentityMonitoring />
              </React.Suspense>
            }
          />
           <Route
            path="/financiallockbox/*"
            element={
              <React.Suspense fallback={<>...</>}>
                <FinancialLockbox  />
              </React.Suspense>
            }
          />
          <Route
            path="/rocketlawyer/*"
            element={
              <React.Suspense fallback={<>...</>}>
                <RocketLawyer />
              </React.Suspense>
            }
          />
          <Route
            path="/savingsgoals/*"
            element={
              <React.Suspense fallback={<>...</>}>
                <SavingsGoals />
              </React.Suspense>
            }
          />
          <Route
            path="/testimonial/*"
            element={
              <React.Suspense fallback={<>...</>}>
                <Testimonial />
              </React.Suspense>
            }
          />
          <Route
            path="/pricing/*"
            element={
              <React.Suspense fallback={<>...</>}>
                <Pricing />
              </React.Suspense>
            }
          />
          <Route
            path="/contactus/*"
            element={
              <React.Suspense fallback={<>...</>}>
                <ContactUs />
              </React.Suspense>
            }
          />
          <Route
            path="/custappnew/*"
            element={
              <React.Suspense fallback={<>...</>}>
                <CustAppNew />
              </React.Suspense>
            }
          />
            <Route
            path="/ppquizhome/*"
            element={
              <React.Suspense fallback={<>...</>}>
                <PPQuizHome />
              </React.Suspense>
            }
          />
          <Route
            path="/privacypolicy/*"
            element={
              <React.Suspense fallback={<>...</>}>
                <PrivacyPolicy />
              </React.Suspense>
            }
          />
          <Route
            path="/termsofuse/*"
            element={
              <React.Suspense fallback={<>...</>}>
                <TermsofUse />
              </React.Suspense>
            }
          />
          <Route
            path="/accessiblitystatement/*"
            element={
              <React.Suspense fallback={<>...</>}>
                <AccessiblityStatement />
              </React.Suspense>
            }
          />
           <Route
            path="/faq/*"
            element={
              <React.Suspense fallback={<>...</>}>
                <FAQ />
              </React.Suspense>
            }
          />
            <Route
            path="/protectionthatpays/*"
            element={
              <React.Suspense fallback={<>...</>}>
                <ProtectionThatPays />
              </React.Suspense>
            }
          />

          {/* For Self Replicate */}
          <Route
            path="/404"
            element={
              <React.Suspense fallback={<>...</>}>
                <NoMatch />
              </React.Suspense>
            }
          />
          <Route path="*" element={<Navigate replace to="/404" />} />
        </Routes>
        <ScrollTopBehaviour />
        <ScrollToTop />
        <Seo />
      </BrowserRouter>
    </div>
  );
}

export default App;
